export default "__VITE_ASSET__B9q7bS9C__"